/* @ngInject */
export default class PreviewController {
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {any} $scope
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 */
	constructor(
		$location,
		$scope,
		$routeParams,
	) {
		this.$location = $location;
		const searchQuery = this.$location.search();

		this.options = {
			params:   {},
			parent:   null,
			preview:  true,
			readOnly: !searchQuery?.edit,
			tree:     false,
			viewMode: 2,
		};

		this.kid = $routeParams.kid;

		$scope.$watch('options.readOnly', (/** @type {boolean} */ readOnly) => {
			if (!$scope.create) {
				const search = this.$location.search();
				if (readOnly) {
					delete search.edit;
				}
				else {
					search.edit = true;
				}
				this.$location.search(search);
			}
		});
	}

	cancel() {
		this.options.readOnly = false;
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} itemKid
	 */
	submit(itemKid) {
		this.$location.url(`/preview/${itemKid}`);
	}
}
